// extracted by mini-css-extract-plugin
export default {"digits":"PriceTag_digits__YGrb2","priceTag":"PriceTag_priceTag__EpiBq","priceTagBig":"PriceTag_priceTagBig__dFLX8","container":"PriceTag_container__qbe5T"};